<template>
	<div
		class="conversions-container"
		:style="`border-bottom: 0.1rem solid ${globalColors.border};border-top: 0.1rem solid ${globalColors.border};`"
	>
		<h3
			:class="['conversions-title']"
			:style="`color:${globalColors.titulo}`"
		>Presentaciones:</h3>
		<div class="conversion-button-container">
			<button
				type="button"
				v-for="(item, index) in conversionsComputed"
				class="btn-conversions"
				:style="`border:1px solid ${globalColors.primary};color: ${item.isSelected ? 'white' : globalColors.primary};background-color: ${item.isSelected ? globalColors.primary : 'white'}`"
				:key="index"
				:value="defaultUnit"
				@click="selectedConversion(item)"
			>
				{{ item.name }}
			</button>
		</div>
	</div>
</template>
<script>
import l from '@/helpers/lib';


function conversionsChanges(conversions) {
	if (conversions) {
		const conversionsFormatted = l.map(
			k => l.setNewProperty('id', Number(k))(conversions[k]),
			Object.keys(conversions),
		);
		this.conversionsComputed = [].concat(this.defaultUnit, conversionsFormatted);
		this.conversionsComputed = this.conversionsComputed.map((p, index) => {
			const newP = { ...p };
			newP.isSelected = index === 0;
			return newP;
		});
	}
}

function selectedConversion(item)	{
	this.conversionsComputed = this.conversionsComputed.map((o) => {
		const newData = { ...o };
		newData.isSelected = item.id === o.id;
		return newData;
	});
	this.$emit('unit-selection', item);
}

function data() {
	return {
		conversionSelected: null,
		conversionsComputed: [],
	};
}

export default {
	name: 'product-conversions',
	data,
	methods: {
		conversionsChanges,
		selectedConversion,
	},
	props: {
		conversions: {
			default: () => {},
			type: Object,
		},
		defaultUnit: {
			default: () => {},
			type: Object,
		},
	},
	watch: {
		conversions: {
			deep: true,
			handler: conversionsChanges,
		},
	},
};
</script>
<style lang="scss" scoped>
	.conversions-container {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		font-size: size(normal);
		justify-content: flex-start;
		margin-top: 10px;
		padding: 20px 0;
	}

	.conversions-title {
		flex: 1 1 auto;
	}

	.conversions-select-container {
		height: 24px;
		margin-left: 10px;
		width: 100%;
	}

	.btn-conversions {
		border-radius: 7px;
		font-family: font(avenirBold);
		font-size: size(medium);
		padding: 1rem;

		&.active {
			background-color: red;
			color: white;
		}
	}

	.conversion-button-container {
		flex: 1 1 70%;

		button {
			margin: 0 5px;
		}
	}
</style>


// WEBPACK FOOTER //
// productConversion.vue?74992741